/**
 * Render a mask when a ui-router roue is being loaded
 */
angular.module('pitch.app')
.directive('routeLoaderMask', function($rootScope) {
    "use strict";
    return {
        restrict: 'A',
        link: function($scope, elem, attr, ctrl) {
            $scope.isLoading = false;

            $rootScope.$on('$stateChangeStart', function() {
                $scope.isLoading = true;
            });

            $rootScope.$on('$stateChangeSuccess', function() {
                $scope.isLoading = false;
            });

            $rootScope.$on('$stateChangeError', function() {
                $scope.isLoading = false;
            });
        },
        template: '<div ng-if="isLoading" class="route-loader-mask"></div>',
        replace: true
    };
})
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/routeLoaderMask.js